import banner1 from '../../img/banner/banner1.webp';
import banner2 from '../../img/banner/banner2.webp';
import banner3 from '../../img/banner/banner3.webp';

    const Imagens = [
        {
            id: 1,
            foto: banner1,
            titulo: 'Tenha uma vida mais saudável'
        },
        {
            id: 2,
            foto: banner2,
            titulo: 'Treine com os melhores profissionais'
        },
        {
            id: 3,
            foto: banner3,
            titulo: 'Alcance seus objetivos'
        }
    ];


export default Imagens;